var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zidingyi_Sousuo",style:(_vm.shu.yangshi)},[_c('span',{staticClass:"tubiao tb-sousuo"}),_c('input',{staticClass:"zidingyi_Sousuo_input",attrs:{"type":"text","placeholder":"请输入搜索内容"}})])}
var staticRenderFns = []

export { render, staticRenderFns }